import { instructionService } from '../_services';

const getDefaultState = () => {
  return {
    saved: {}
  }
}

export const instructions = {
  namespaced: true,
  state: getDefaultState(),
  actions: {
    resetState ({ commit }) {
      commit('resetState')
    },
    setSavedInstructions({ commit }, instructions) {
      commit('setSavedInstructionsRequest');
      commit('setSavedInstructionsSave', instructions);
    },
    getSavedInstructions({ commit }) {
        commit('getSavedInstructionsRequest');
    },
    clearSavedInstructions({ commit }) {
      commit('clearSavedInstructionsRequest');
    },
  },
  mutations: {
    resetState (state) {
      Object.assign(state, getDefaultState())
    },
    setSavedInstructionsRequest(state) {
        state.saved = { loading: true };
    },
    setSavedInstructionsSave(state, instructions) {
        state.saved = Object.values(instructions);
        return 'setSavedInstructionsSave: Saved';
    },
    getSavedInstructionsRequest(state) {
        return state.saved;
    },
    clearSavedInstructionsRequest(state) {
        state.saved = '';
    },
  }
}